import { Close } from '@atom-learning/icons'
import React, { useEffect } from 'react'

import { cn } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Dismissible } from '../dismissible'
import { Icon } from '../icon/Icon'
import { useSectionMessageContext } from './SectionMessageContext'

export const SectionMessageDismiss = ({
  label = 'Dismiss',
  className,
  ...rest
}: React.ComponentProps<typeof ActionIcon>): React.JSX.Element => {
  const { setHasDismiss } = useSectionMessageContext()

  useEffect(() => {
    setHasDismiss(true)
    return () => setHasDismiss(false)
  }, [setHasDismiss])

  return (
    <Dismissible.Trigger asChild>
      <ActionIcon
        label={label}
        size="sm"
        appearance="simple"
        theme="neutral"
        {...rest}
        className={cn('m-auto', 'absolute', 'top-2', 'right-2', className)}
      >
        <Icon is={Close} />
      </ActionIcon>
    </Dismissible.Trigger>
  )
}
